export default __webpack_public_path__ + "static/media/logo-memed-novo.16d518e8.svg";